<template>
	<div>
        <div class="card-body overflow-auto">
             <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div class="text-right float-end">
                            <a :href="'/user_dataset?format=raw&amp;dataset=scored-'+passedData+'.csv'" class="btn btn-sm btn-primary"><i class="fas fa-file"></i> Download CSV</a>
                        </div>
                    </div>
                </div>
             </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col col-lg-4">
                        <div class="form-group">
                            <label>Entries per Page</label>
                            <select class="form-select" v-model="perPage" @click="fetchData()">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                    <div class="col col-lg-4 d-none">
                        <div class="form-group">
                            <label>Sort By</label>
                            <select class="form-select" v-model="sortBy" @click="fetchData()">
                                <option v-for="(header, index) in headers" :value="index" :key="header.value">{{header.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col col-lg-4 d-none">
                        <div class="form-group">
                            <label>Sort Type</label>
                            <select class="form-select" v-model="sortType" @click="fetchData()">
                                <option value="ASC">Ascending</option>
                                <option value="DESC">Descending</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <th scope="col" v-for="(header, index) in headers" :key="index"><button @click="setSort(index)" class="btn btn-link">{{ header.text }} <i v-if="(sortBy === index && sortType === 'ASC')" class="fas fa-chevron-up"></i><i v-if="(sortBy === index && sortType === 'DESC')" class="fas fa-chevron-down"></i></button></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, num) in items" :key="num">
                    <td v-for="(header, index) in headers" :key="index">{{ item[header.value] }}</td>
                </tr>
                </tbody>
            </table>
            <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group me-2" role="group" aria-label="First group">
                <button class="btn btn-outline-primary" :disabled="currentPage === 1" @click="firstPage">First</button>
                <button class="btn btn-outline-primary" :disabled="currentPage === 1" @click="prevPage">Previous</button>
            </div>
            <div class="btn-group h-100" role="group" aria-label="Third group">
                <div class="h-100 text-center inline-block align-middle p-2">Page {{ currentPage }} of {{ totalPages }}</div>
            </div>
            <div class="btn-group me-2" role="group" aria-label="Second group">
                <button class="btn btn-sm btn-outline-primary" :disabled="currentPage === totalPages" @click="nextPage">Next</button>
                <button class="btn btn-sm btn-outline-primary" :disabled="currentPage === totalPages" @click="lastPage">Last</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            headers: [],
            items: [],
            currentPage: 1,
            perPage: 10,
            totalItems: 0,
            loading: false,
            sortBy: 0,
            sortType: 'DESC'
        }
    },
    props: {
        passedData: {
        type: String,
        default() {
            return 'Dataset'
        }
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.perPage);
        },
    },
    methods: {
        setSort(index) {
            this.sortBy = index;
            if(this.sortType == 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }
            this.fetchData();
        },
        getFileInfo(dataset) {
            axios.get('/file_info', { params: {filename: 'scored-'+this.passedData + '.csv', directory: 'datasets'} })
            .then(
                (response) => {
                    this.totalItems = response.data;
                }
            )
        },
        getTableheaders() {
            axios.get('/return_table_headers', { params: {dataset: 'scored-'+this.passedData + '.csv'} })
            .then(
                (response) => {
                    var initheaders = response.data;
                    var finheaders = [];
                    initheaders.forEach(element => {
                        finheaders.push({ text: element, value: element, sortable: true})
                    });
                    this.headers = finheaders;
                }
            )
        },
        async fetchData() {
            const datasetName = 'scored-'+this.passedData;
            this.loading = true;
            try {
                const response = await axios.get('/file_data_load', {
                params: {
                    dataset: datasetName + '.csv', 
                    format: 'json',
                    chunksize: this.perPage, 
                    sortorder: this.sortBy, 
                    sortvector: this.sortType,
                    start_row: (this.currentPage*this.perPage) - this.perPage + 1
                },
                });
                this.items = response.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchData();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchData();
            }
        },
        firstPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage = 1;
                this.fetchData();
            }
        },
        lastPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage = this.totalPages;
                this.fetchData();
            }
        }
    },
    watch: {
        currentPage(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.fetchData();
        }
        }
    },
    mounted() {
        this.getFileInfo();
        this.getTableheaders();
        this.fetchData();
    }
}
</script>